import * as types from "../actions/actionTypes";

// This device's host identity, as confirmed by the server (see actions/hostActions.js).
export const initialHostState = {
  hasKey: false, // a host key is stored on this device
  userId: null, // the identity the server resolved the key to
  canPublish: false, // may add songs to the public list
  loaded: false, // the server has been asked at least once
};

export default function hostReducer(state = initialHostState, action) {
  switch (action.type) {
    case types.HOST_SET:
      return { ...state, ...action.host, loaded: true };

    default:
      return state;
  }
}
